import { render, staticRenderFns } from "./PageContentImportExport.vue?vue&type=template&id=5ec11f92&"
import script from "./PageContentImportExport.vue?vue&type=script&lang=js&"
export * from "./PageContentImportExport.vue?vue&type=script&lang=js&"
import style0 from "./PageContentImportExport.vue?vue&type=style&index=0&id=5ec11f92&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ec11f92')) {
      api.createRecord('5ec11f92', component.options)
    } else {
      api.reload('5ec11f92', component.options)
    }
    module.hot.accept("./PageContentImportExport.vue?vue&type=template&id=5ec11f92&", function () {
      api.rerender('5ec11f92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pages/page-content/PageContentImportExport.vue"
export default component.exports